export class Usuario {
  login: string;
  clave: string;
  tipo: string;
  token: string;

  constructor() {

    this.login = '';
    this.clave = '';
    this.tipo = '';
    this.token = '';

  }

}
